module.exports = __webpack_public_path__ + "root-c2082cbd/3fb76e34a6cecc582e948ec52d141447.woff2";